var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocalMallBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.389 22q-.78 0-1.334-.56a1.84 1.84 0 0 1-.555-1.345V8.667q0-.786.555-1.346t1.334-.56h1.889q0-1.976 1.381-3.368Q10.039 2 12 2q1.96 0 3.341 1.393 1.38 1.392 1.381 3.369h1.89q.778 0 1.333.56.555.558.555 1.345v11.428q0 .786-.555 1.346T18.611 22zm0-1.905H18.61V8.667H5.39zM9.167 6.762h5.666q0-1.19-.826-2.024A2.72 2.72 0 0 0 12 3.905q-1.18 0-2.007.833a2.77 2.77 0 0 0-.826 2.024m2.81 7.619q1.746 0 3.163-1.167 1.418-1.166 1.393-2.619a1 1 0 0 0-.26-.69.85.85 0 0 0-.66-.286.9.9 0 0 0-.59.214q-.26.214-.379.643a2.65 2.65 0 0 1-1.015 1.453 2.76 2.76 0 0 1-1.653.547 2.8 2.8 0 0 1-1.664-.547 2.5 2.5 0 0 1-1.004-1.453q-.117-.452-.354-.655a.84.84 0 0 0-.567-.202.9.9 0 0 0-.672.286.97.97 0 0 0-.272.69q0 1.452 1.393 2.62 1.394 1.166 3.14 1.166"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalMallBag);
export default __webpack_public_path__ + "static/media/local_mall_bag.f09c261b7d80b90dc88e8cec63d8eda4.svg";
export { ForwardRef as ReactComponent };